export default {
  position: 'dashboard',
}
